import moment from 'moment';

export function getTooltipTransform(placement, align) {
  const yTransform = placement === 'top' ? 'translateY(-100%)' : 'translateY(8px)';
  if (align === 'left') return `translateX(0) ${yTransform}`;
  if (align === 'right') return `translateX(-100%) ${yTransform}`;
  return `translateX(-50%) ${yTransform}`;
}

export function getArrowLeft(align) {
  if (align === 'left') return '12px';
  if (align === 'right') return 'calc(100% - 12px)';
  return '50%';
}

// Re-export styled components from the .styled.js file
export {
  TooltipContainer,
  TooltipHeader,
  HeaderLeft,
  IconCircle,
  HeaderTitle,
  HeaderActions,
  IconButton,
  TooltipDescription,
  TitleText,
  TooltipMeta,
  MetaItem,
  MetaIcon,
  TooltipActions,
  ActionButton,
  SeverityPill,
} from './TooltipCommon.styled';

export function getSeverityColor(severity) {
  return ({
    critical: '#D32F2F',
    high: '#F57C00',
    warning: '#F57C00',
    medium: '#FFA000',
    fair: '#FFA000',
    low: '#4CAF50',
    good: '#2E7D32'
  }[String(severity || '').toLowerCase()] || '#757575');
}

export const formatAnnotationType = type => (type && type.replace ? type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : '');

export function formatDuration(startTime, endTime) {
  const start = moment(startTime);
  const end = endTime ? moment(endTime) : null;
  const timeFormat = 'DD/MM/YYYY HH:mm';

  if (!endTime || endTime === startTime) {
    return start.isValid() ? start.format(timeFormat) : '-';
  }

  const startStr = start.isValid() ? start.format(timeFormat) : '-';
  const endStr = end && end.isValid() ? end.format(timeFormat) : '-';
  return `${startStr} - ${endStr}`;
}
